/**
 * 权限控制指令
 * 用于控制按钮和元素的显示/隐藏
 * 
 * 使用方式:
 * v-permission="'system:user:add'" - 有指定权限才显示
 * v-permission:any="['system:user:add', 'system:user:edit']" - 有任意一个权限就显示
 * v-permission:all="['system:user:add', 'system:user:edit']" - 有所有权限才显示
 */

import { hasPermission, hasAnyPermission, hasAllPermissions } from '@/utils/auth.js'

export const permission = {
  mounted(el, binding) {
    const { value, modifiers } = binding
    let hasAuth = false

    if (modifiers.any) {
      // 有任意一个权限
      hasAuth = hasAnyPermission(value)
    } else if (modifiers.all) {
      // 有所有权限
      hasAuth = hasAllPermissions(value)
    } else {
      // 有指定权限
      hasAuth = hasPermission(value)
    }

    if (!hasAuth) {
      el.parentNode?.removeChild(el)
    }
  }
}

export const permissionBtn = {
  mounted(el, binding) {
    const { value } = binding
    const hasAuth = hasPermission(value)

    if (!hasAuth) {
      // 禁用按钮而不是移除
      el.disabled = true
      el.classList.add('is-disabled')
      el.style.cursor = 'not-allowed'
      el.style.opacity = '0.6'

      // 阻止点击事件
      el.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
      }, true)
    }
  }
}

export default {
  install(app) {
    app.directive('permission', permission)
    app.directive('permission-btn', permissionBtn)
  }
}
